<template>
  <div>

    <div class="card card-info">
      <div class="card-header with-border">
        <h3 class="card-title">Department Coordinator</h3>
      </div>
      <!-- /.card-header -->
      <!-- form start -->
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="row">

              <div class="col-md-6">
                <label>Semester/Term</label>
                <select class="form-control" v-model="ActiveSemesterID" required>
                  <option value="">--Select Semester--</option>
                  <option v-for="item in semester" v-bind:value="item.SemesterID">{{item.Name}}</option>
                </select>
              </div>

              <div class="col-md-6">
                <label>Program</label>
                <select class="form-control" v-model="ProgramID" required>
                  <option value="">--Select Program--</option>
                  <option value="0">All</option>
                  <option v-for="item in program" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                </select>
              </div>

            </div>
          </div>
        </div>
      </div>
      <hr />
      <!--Button -->
      <div class="card-footer">
        <button class="btn btn-success float-right" style="width: 120px" type="submit" v-on:click="search()">Search</button>
        <button class="btn btn-info float-right" style="width: 120px; margin-right:5px" v-if="ProgCourseWiseStudentCount.length != 0" v-on:click="print()">Print</button>
        <button class="btn btn-danger" style="width: 120px" type="button" v-on:click="clear()">Cancel</button>
      </div>

    </div>
    <div class="card card-info" v-show="showgrid === 'true'">
      <div class="card-header with-border">
        <h3 class="card-title">Program Course wise Student Count</h3>
      </div>
      <!-- /.card-header -->
      <!-- form start -->
      <div class="card-body">
        <div class="row">
          <div class="col-md-12" style="padding-right: 3%; padding-left: 3%; padding-top: 2%">
            <h4 style="text-align:center; margin-bottom:25px" v-if="ProgCourseWiseStudentCount.length == 0">No record Found</h4>
            <table class="table table-bordered table-sm table-responsive table-color" v-for="head in ProgCourseWiseStudentCount">
              <thead class="bg-info">
                <tr>
                  <th class="text-center" colspan="6">
                    <h4>{{head.ProgramName}} - {{head.SessionName}}</h4>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="bg-info">
                  <th width="5%">Sr. No.</th>
                  <th width="25%">Subject</th>
                  <th width="25%">Instructor Name</th>
                  <th width="10%">Course Code</th>
                  <th width="5%">Credit Hrs</th>
                  <th width="10%">No Of Students</th>
                </tr>
                <tr v-for="(item, ind) in head.Child">
                  <td>{{ind+1}}</td>
                  <td>{{item.CourseName}}</td>
                  <td>{{item.Name}}</td>
                  <td>{{item.CourseCode}}</td>
                  <td>{{item.CreditHours}}</td>
                  <td>{{item.NoOfStudents}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        ProgramID: '',
        ActiveSemesterID: '',
        program: [],
        semester: [],
        grid: 'hide',
        showgrid: 'false',
        ProgCourseWiseStudentCount: [],
      }
    },
    created: function () {
      this.pageload();
    },

    updated: function () {
      $('#bs4').DataTable();
    },
    methods:
    {
      changestate() {
        this.showgrid = 'false';
      },

      pageload() {
        var vm = this;
        axios.post('/api/DCApi/loadStudentcountPage')
          .then(function (response) {
            vm.program = response.data.prog;
            vm.semester = response.data.semester;
          })
      },

      search() {
        var vm = this;
        axios.post('/api/DCApi/SearchStudentCount?progID=' + vm.ProgramID + '&semID=' + vm.ActiveSemesterID)
          .then(function (response) {
            vm.showgrid = 'true'
            $('#bs4').DataTable().destroy();
            vm.ProgCourseWiseStudentCount = response.data.lst;
          })
      },

      print() {
        var vm = this;
        axios.post('/api/DCApi/SearchStudentCount?progID=' + vm.ProgramID + '&semID=' + vm.ActiveSemesterID)
          .then(function (res) {
            window.open("/DC/ProgCourseWiseStudentCountPrint?progID=" + vm.ProgramID + '&semID=' + vm.ActiveSemesterID , "_blank");
          })
      },

      clear() {
        window.location.reload();
      }
    },
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/progCourseWiseStudentCount.vue